module.exports = __webpack_public_path__ + "media/qipaGame.1e455147.mp4";